import { useEffect } from "react";
import { useAuth } from "@pravaler/amigoedu-ui/dist/components/Auth";
import { useRouter } from "next/router";
import { updateUserInfo } from "../../utils/auth";
import { useAuthApollo } from "@lib/apolloClientConfig";
interface ISignModalProps {
	onLogin: () => void;
}
export const SignModal = ({ onLogin }: ISignModalProps): JSX.Element => {
	const client = useAuthApollo({});
	const history = useRouter();

	const { token, user, authOperation } = useAuth();

	useEffect(() => {
		if (token && user?.id) {
			// obtem os dados de login do amigoedu-ui
			const userAuthData = {
				token,
				user,
			};
			// funcoes pós REGISTRO
			if (authOperation === "register") {
				updateUserInfo(userAuthData, client);
			} else {
				// funcoes pós SIGN_IN
				updateUserInfo(userAuthData, client);
				onLogin();
			}
		}
	}, [user, token, authOperation]);

	return <div />;
};

export default SignModal;
